var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"grid-container"},_vm._l((_vm.success),function(successItem,index){return _c('div',{key:index + 'grid',staticClass:"grid-item"},[_c('img',{attrs:{"src":successItem.src,"alt":""}}),_c('h3',[_vm._v(_vm._s(successItem.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }